import { useDebounce, useMediaQuery } from "@uidotdev/usehooks";
import { breakpoints } from "../components/design-tokens";

export function useIsMobile(debounceMs: number = 150) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.md - 1}px)`);
  return useDebounce(isMobile, debounceMs);
}
